import {
  hairbookGlobalImageUrl,
  hairbookPostDownloadUrl,
  magazineHeroVideoMp4Url,
} from "@/lib/_url";
import type { MagazineArticle } from "./_props";

export type MagazineHeroVideoKind = "r2" | "post" | "global";

export type MagazineHeroVideoSource = {
  kind: MagazineHeroVideoKind;
  src: string;
};

export type MagazineHeroVideoConversionStatus = "converting" | "ready" | "failed";

/** Studio-compatible sidecar at `magazine/videos/<id>/conversion.json`. */
export type MagazineHeroVideoConversion = {
  status: MagazineHeroVideoConversionStatus;
  source_key?: string;
  delivery_key?: string;
  error?: string | null;
  updated_at?: string;
};

/**
 * Console treats a missing sidecar as ready when `source.mp4` exists.
 * Pages uses the same rule when a sidecar probe result is available.
 */
export function isMagazineHeroVideoReady(
  conversion: MagazineHeroVideoConversion | null | undefined,
  sourceMp4Available: boolean,
): boolean {
  if (conversion?.status === "ready") return true;
  if (conversion == null && sourceMp4Available) return true;
  return false;
}

/**
 * Backfill and replace: if Console wrote `hero_video_id`, play only that R2
 * file. Legacy post / global_image video stay until backfill lands — they are
 * not an onError fallback from R2.
 */
export function resolveMagazineHeroVideo(
  article: Pick<MagazineArticle, "embeds" | "globalImageId" | "globalImageCategory">,
): MagazineHeroVideoSource | null {
  const heroVideoId = article.embeds.hero_video_id;
  if (heroVideoId) {
    return { kind: "r2", src: magazineHeroVideoMp4Url(heroVideoId) };
  }

  const heroVideoPostId = article.embeds.hero_video_post_id;
  if (heroVideoPostId) {
    return { kind: "post", src: hairbookPostDownloadUrl(heroVideoPostId) };
  }

  if (article.globalImageCategory === "video" && article.globalImageId) {
    return { kind: "global", src: hairbookGlobalImageUrl(article.globalImageId) };
  }

  return null;
}
